import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";
import { AuthShell, ErrorBox } from "@/pages/LoginPage";

const inputCls = "bg-card border-border text-foreground h-11 rounded-[var(--radius)]";

export default function ChangePasswordPage({ user, onDone, onLogout }) {
  const [current, setCurrent] = useState("");
  const [next, setNext]       = useState("");
  const [repeat, setRepeat]   = useState("");
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== repeat) {
      setError("Die neuen Passwörter stimmen nicht überein");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Passwort geändert");
      onDone();
    } catch (err) {
      setError(err.response?.data?.detail || "Passwort konnte nicht geändert werden");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <p className="text-sm font-semibold text-foreground">Neues Passwort festlegen</p>
          <p className="text-xs text-muted-foreground mt-1">
            Angemeldet als {user.username}. Mindestens 12 Zeichen und drei von: Klein-, Großbuchstaben, Ziffern, Sonderzeichen.
          </p>
        </div>
        <Input type="password" autoComplete="current-password" placeholder="Aktuelles bzw. Einmal-Passwort"
               value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} autoFocus />
        <Input type="password" autoComplete="new-password" placeholder="Neues Passwort"
               value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
        <Input type="password" autoComplete="new-password" placeholder="Neues Passwort wiederholen"
               value={repeat} onChange={(e) => setRepeat(e.target.value)} className={inputCls} />
        {error && <ErrorBox>{error}</ErrorBox>}
        <Button type="submit" disabled={loading || !current || !next || !repeat}
                className="w-full h-11 bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary)/0.85)] text-[hsl(var(--primary-foreground))] font-semibold rounded-[var(--radius)]">
          {loading ? "Speichere…" : "Passwort speichern"}
        </Button>
        <button type="button" onClick={onLogout} className="w-full text-xs text-muted-foreground hover:text-foreground">
          Abmelden
        </button>
      </form>
    </AuthShell>
  );
}
